import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import FETCH from "../../../../utils/fetch";
import "../style/debtPayOff.css";
import NewLoader from "../../../styled-components/loader/NewLoader";
import filterIcon from "../../../../assets/images/debtPayoff/filter.png";
import { ChartColors } from "../../../ChartColors";
import { Dropdown, Menu } from "antd";
export const DebtList = (props) => {
  const history = useHistory();
  function getRandomDarkColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  
  const [data, setData] = useState([]);
  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data]);
  const sortData = (sortBy) => {
    let sortedData;
    switch (sortBy) {
      case "alphabetical":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (a.module && b.module) {
              return a.module.localeCompare(b.module);
            } else {
              return 0; // No sorting if category name is missing
            }
          });
        break;
      case "maturityDate":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (a["Maturity Date"] && b["Maturity Date"]) {
              return (
                new Date(a["Maturity Date"]) - new Date(b["Maturity Date"])
              );
            } else {
              return 0; // No sorting if maturity date is missing
            }
          });
        break;
      case "creditBalance":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (
              a["Credit Balance"] !== undefined &&
              b["Credit Balance"] !== undefined
            ) {
              return a["Credit Balance"] - b["Credit Balance"];
            } else {
              return 0; // No sorting if credit balance is missing
            }
          });
        break;
      case "initialLoanAmount":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (
              a["Initial Loan Amount"] !== undefined &&
              b["Initial Loan Amount"] !== undefined
            ) {
              return a["Initial Loan Amount"] - b["Initial Loan Amount"];
            } else {
              return 0; // No sorting if initial loan amount is missing
            }
          });
        break;
      case "interestRate":
        sortedData =
          data &&
          [...data].sort((a, b) => {
            if (
              a["Interest Rate"] !== undefined &&
              b["Interest Rate"] !== undefined
            ) {
              return a["Interest Rate"] - b["Interest Rate"];
            } else {
              return 0; // No sorting if interest rate is missing
            }
          });
        break;
      default:
        sortedData = data && [...data];
    }
    setData(sortedData);
    // return sortedData;
  };

  // Example usage
  const liabilityEdit = (record) => {
    history.push(
      `/liabilities_credit_new/attributes/${record.module}/${record.id}`
    );
  };
  return (
    <div style={{ position: "relative" }}>
      {" "}
      <div
        className="cardHeadingDebt"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap:"4px"
        }}
      >
        Debts
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
          <div
            className="filterIcons"
            onClick={() => {
              // setDropdown(!dropdown);
            }}
          >
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("alphabetical");
                      }}
                    >
                      Alphabetical
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("maturityDate");
                      }}
                    >
                      Date
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("initialLoanAmount");
                      }}
                    >
                      Amount
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        sortData("interestRate");
                      }}
                    >
                      ARP
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <img src={filterIcon} height={24} width={24} alt="icon"></img>
              </a>
            </Dropdown>
          </div>
          <button
            className="addbuttonLiablity"
            onClick={() => {
              history.push("/liabilities_credit_new");
            }}
          >
            {" "}
            + Add
          </button>
        </div>
      </div>
      <div className="listingContainer" style={{paddingInline:"8px"}}>
        <React.Fragment>
          {data && data && data.length > 0 ? (
            data.map((item, index) => (
              <div
                key={index}
                className="list-row"
                style={{ 
                  background: ChartColors[index % ChartColors.length], // Cycle through ChartColors
                  // background: getRandomDarkColor(),
                  gap:"1rem"
                 }}
                onClick={() => {
                  liabilityEdit(item);
                  // history.push({
                  //   pathname: "/debtDetails",
                  //   // state: { from: location.state.from },
                  //   details: item,
                  // });
                }}
              >
                <div className="listname">
                  {item["Nickname of Liabilities"]
                    ? item["Nickname of Liabilities"]
                    : "Nickname"}
                </div>
                <div className="">
                  $
                  {item["Initial Loan Amount"]
                    ? item["Initial Loan Amount"]
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0}
                </div>
                <div className="">
                  {item["Length of Loan (No of years remaining)"]
                    ? "Payoff in " +
                      item["Length of Loan (No of years remaining)"]
                    : "N/A"}
                </div>
              </div>
            ))
          ) : (
            <div className="nodata">No Data to Show</div>
          )}
        </React.Fragment>
      </div>
      <NewLoader isLoading={props.loading} />
    </div>
  );
};
